gsap.registerPlugin(ScrollTrigger);
function hide(elem){
	gsap.set(elem, {autoAlpha: 0});
}

const cleanVideoElem = document.querySelector('#video1');
let cleanVideo = '';


ScrollTrigger.matchMedia({
	// desktop
	"(min-width: 769px)": function () {
		// setup animations and ScrollTriggers for screens over 800px wide (desktop) here...
		// ScrollTriggers will be reverted/killed when the media query doesn't match anymore.
		//sub3-1 커버 이미지 효과
		const endPin = document.querySelector('.js-end-pin');
		const gradientBg = document.querySelector(".gradient-bg");

		if(endPin){
			let tl = gsap.timeline({
				scrollTrigger: {
					trigger: ".pin-layer",
					start: "top top",
					end: endPin.offsetTop,
					scrub: true,
					pin: ".pin-layer",
					anticipatePin: 1,
					//markers:true
					//onEnter: () => {video02Player.play()},
					onEnterBack: () =>gradientBg.classList.remove('hide'),
					onLeave: () => gradientBg.classList.add('hide')
				}
			});
			tl.fromTo(".gradient-bg", {
				opacity: 0,
				ease: "none",
				duration: 200
			},{opacity:1});
			tl.fromTo(".pin-layer", {
				opacity: 1,
				ease: "none",
				duration: 500
			},{opacity:0})
			
		}
		

		//심플한 핀
		let pin = gsap.timeline({
			scrollTrigger: {
				trigger: ".pin-simple-container",
				start: "top top",
				end: "bottom 80%",
				scrub: true,
				pin: ".pin-simple",
			}
		});

	},
	// mobile
	"(max-width:768px)": function () {
		// Any ScrollTriggers created inside these functions are segregated and get
		// reverted/killed when the media query doesn't match anymore.
		function removeClass(elem,className){
			let max = elem.length;
			for(let i=0;i<max; i++){
				elem[i].classList.remove(className);
			}
		}
		let clickEvent = (function () {
			if ('ontouchstart' in document.documentElement === true) {
				return 'touchstart';
			} else {
				return 'click';
			}
		})();
		let menuItem = document.querySelector('#menu-main-menu');

		menuItem.addEventListener(clickEvent,function(e){
			this.tg = e.target;
			this.menuList = this.tg.parentNode;
		
			if(this.tg.nextElementSibling.classList.contains('gnb-depth2')) {
				e.preventDefault();
				if(this.menuList.classList.contains('active')){
					//클릭한 메뉴에 active가 있을때
					removeClass(menuItem,'on');
					this.menuList.classList.remove('active');
					gsap.fromTo(this.menuList,{
							height: this.tg.offsetHeight + this.tg.nextElementSibling.offsetHeight,
						},
						{
							height: this.tg.offsetHeight,
							duration: .6
						});
				} else if(!this.menuList.classList.contains('on')){
					//내가 클릭한 메뉴에 on이 없을때 active가 없을때
					removeClass(menuItem,'on');
					this.menuList.classList.add('on');
					gsap.to(this.menuList,
						{
							height: this.tg.offsetHeight + this.tg.nextElementSibling.offsetHeight,
							duration: .6
						});
				} else{
					//클릭한 메뉴에 이미 on이 있을때
					this.menuList.classList.remove('on');
					gsap.to(this.menuList,
						{
							height: this.tg.offsetHeight,
							duration: .6
						});
				}
				
			}
		
		});
	},
	// all 
	"all": function () {
		// ScrollTriggers created here aren't associated with a particular media query,
		// so they persist.

		//헤더 클래스명 부분
		ScrollTrigger.create({
			trigger: '#topVisual',
			start: '100px top',
			end: 99999,
			toggleClass: {
				targets: '.main-header, .hamberger',
				className: 'contentStart'
			},
		});

		let visualTl = gsap.timeline({
			scrollTrigger: {
				trigger: ".top-bnr-area",
				start: "top top",
				//end: "+=500", // end after scrolling 500px beyond the start
				scrub: true,
			}
		});

		visualTl.to(".top-bnr-area .center-box", {autoAlpha: 0});
			



		if(cleanVideoElem){

			let cleanVideoTl = gsap.timeline({
				// yes, we can add it to an entire timeline!
				scrollTrigger: {
					trigger: '#video1',
					start: 'top bottom',
					onEnter: () => {
						if(cleanVideo == ''){
							cleanVideo = new Vimeo.Player('video1', {
								id: 502878762,
								width: 1920,
								background: true
							});
						} else{
							cleanVideo.play();
						}
					},
					onLeave: () => {cleanVideo.pause();},
					onEnterBack: () => {cleanVideo.play();},
					onLeaveBack: () => {cleanVideo.pause();},
					//markers:true
				}
			});
		}

		gsap.utils.toArray(".gs_reveal").forEach(function (elem, index) {

			hide(elem); // assure that the element is hidden when scrolled into view
			const getDelay = elem.getAttribute('data-gs-delay');
		
			var x = 0,
				y = 60,
				z = -100;
		
			if (elem.classList.contains('reveal_fromDown')) {
				y = -12
			} else if(elem.classList.contains("reveal_fromUp")){
				y = 12;
			} else if (elem.classList.contains("reveal_fromRight")) {
				x = 30;
				y = 0;
				z = 10;
			} else if (elem.classList.contains("reveal_fromLeft")) {
				x = -300;
				y = 0;
				z = 10;
			} 
			gsap.fromTo(elem, {
				x: x,
				y: y,
				z: z,
				autoAlpha: 0
			}, {
				scrollTrigger: {
					trigger: elem.parentNode,
					start: 'top 66%',
					toggleActions: 'play none none none',
					//markers:true
				},
				duration: .8,
				x: 0,
				y: 0,
				z: 0,
				autoAlpha: 1,
				ease: Back.easeOut,
				overwrite: "auto",
				delay: getDelay * 0.001
			});
		});

		gsap.utils.toArray(".zoomIn").forEach(function(elem) {
			const tg = elem.querySelector('.zoomInImg');
			hide(tg); // assure that the element is hidden when scrolled into view
			const getDelay = elem.getAttribute('data-gs-delay');
			const gsDelay = (getDelay / 1000) | 0;
		
			gsap.fromTo(tg, {scale:1.2, autoAlpha: 0 }, {
				scrollTrigger:{
					trigger: elem,
					start:'top 75%',
					toggleActions: 'play none none none'
				},
				duration: 2.5, 
				scale: 1,
				autoAlpha: 1, 
				ease: "expo",
				overwrite: "auto",
				delay:gsDelay
			});
		
		});


		
		gsap.to(".panel:not(:last-child)", {
			yPercent: -100, 
			ease: "none",
			stagger: 0.5,
			scrollTrigger: {
				trigger: ".pin-container",
				start: "top top",
				end: "+=300%",
				scrub: true,
				pin: true
			}
		});
		
		
		gsap.set(".panel", {zIndex: (i, target, targets) => targets.length - i});

		gsap.to('.bg-bk-ani',{
			scrollTrigger:{
				trigger: '.bg-bk-ani',
				start:'top center',
				toggleActions: 'play none none reverse',
				toggleClass:'complete'
			},
			backgroundColor:'#000',
			duration: .8,
			//ease: "expo",
			overwrite: "auto"
		});

		gsap.to('.bg-bk-ani2',{
			scrollTrigger:{
				trigger: '.clean-sys-sect',
				start:'top center',
				end:'bottom center',
				toggleActions: 'play reverse play reverse',
				//toggleClass:'complete'
			},
			backgroundColor:'rgba(0, 0, 0,.8)',
			duration: .4,
			//ease: "expo",
			overwrite: "auto"
		});

	}
});